import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#0d47a1" },
    secondary: { main: "#00695c" },
    background: { default: "#f5f7fa", paper: "#ffffff" },
  },
  typography: {
    fontFamily:
      '"Inter", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
  },
  shape: { borderRadius: 10 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
          borderRadius: 14,
          transition:
            "transform .25s cubic-bezier(.22,1,.36,1), box-shadow .25s",
        },
        contained: {
          background:
            "linear-gradient(93deg,#0D47A1 0%,#0055FF 50%,#001645 100%)",
          color: "#fff",
          boxShadow: "0 8px 24px rgba(0,85,255,.35)",
          "&:hover": {
            transform: "translateY(-2px) scale(1.02)",
            boxShadow: "0 14px 40px rgba(0,85,255,.5)",
          },
          "&:active": {
            transform: "translateY(0) scale(.98)",
          },

          // minWidth: 180,
          px: 2.5,
          py: 1.25,
          borderRadius: "12px",
          background:
            "linear-gradient(93deg,#0D47A1 0%,#0055FF 50%,#001645 100%)",
          color: "#fff",
          fontWeight: 600,
          textTransform: "none",
          boxShadow: "0 8px 24px rgba(0,85,255,.35)",
          transition:
            "transform .25s cubic-bezier(.22,1,.36,1), box-shadow .25s",
          "&:hover": {
            background:
              "linear-gradient(93deg,#0D47A1 0%,#0055FF 50%,#001645 100%)",
            transform: "translateY(-2px) scale(1.02)",
            boxShadow: "0 14px 40px rgba(0,85,255,.5)",
          },
          "&:active": {
            transform: "translateY(0) scale(.98)",
          },
          "&.Mui-disabled": {
            opacity: 0.6,
            background: "rgba(0, 0, 0, 0.12)",
            color: "rgba(0, 0, 0, 0.40)",
          },
        },
        outlined: {
          background: "#fff",
          color: "#001645",
          borderRadius: "12px",
          border: "1px solid #E5E7EB",
          boxShadow: "0 2px 10px rgba(0,22,69,.06)",
          "&:hover": {
            borderColor: "#00B6FF",
            transform: "translateY(-2px)",
            boxShadow: "0 10px 28px rgba(0,182,255,.2)",
            backgroundColor: "#fff",
          },
          "&:active": {
            transform: "translateY(0)",
          },
        },
      },
    },
  },
});

export default theme;
